import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// // API for creating Production old  entry
// export const postProduction = (payload, headers) => {
//   return Axios.post(`addProductionDetails`, payload, {
//     headers,
//   });
// };

// API for creating production entry
export const postProduction = (payload, headers) => {
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/production/addProductionDetails?fkUserId=${fkUserId}&role=${role}`, payload, {
    headers,
  });
};

export const getProductionListWithoutPagination = (headers) => {
  return Axios.get(`/production/getProductionListWithoutPagination`, {
    headers,
  });
};

// API for getting list of all Production
export const getProductionList = (pageNo, fkUserId, role, headers) => {
  return Axios.get(`/production/getProductionDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`, {
      headers,
    }
  );
};

// export const getProductionList = (pageNo, fkUserId, role) => {
//   const token=sessionStorage.getItem("token")
//   return Axios.get(
//     `/production/getProductionDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
//     {
//       withCredentials: true,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       }
//     }
//   );
// };


export const getProductPdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Pdf"];
  return Axios.get(
    `/production/getProductionDetailsReportPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `productiondetailsreport.pdf`);
  });
};

// API for getting list of all field visit by from and to date
export const getProductEntryByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  return Axios.get(
    `/production/getProductionDetailsListBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};



export const getProductEntryPdfDownload = (fromDate, toDate) => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Pdf"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/production/getProductionDetailsReportPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `productiondetailsreport.pdf`);
  });
};

export const getProductAllPdfDownload = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Pdf"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/production/getProductionDetailsListExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `productionList.pdf`);
  });
}

export const getProductAllExcelDownload = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/production/getProductionDetailsListExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `productionList.xlsx`);
  });
};


export const getProductEntryExcelDownload = (fromDate, toDate) => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/production/getProductionDetailsReportPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `productiondetailsreportbetweentwodate.xlsx`);
  });
};

// Api to get board detail by Process Number
export const getProductionDetailsForGetData = (processNo, headers) => {
  return Axios.get(`/production/getProductionDetailsForGetData/${processNo}`, {
    headers,
  })
};


export const getproductiondsipenserserialNo = (pageNo, dispenserSrNo) => {
  const role = sessionStorage.getItem("role");
  const fkUserId = sessionStorage.getItem("pkUserId");
  const token = sessionStorage.getItem("token");

  console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/production/getProductionDetailsListByDispenser/${pageNo}?role=${role}&fkUserId=${fkUserId}&dispenserSrNo=${dispenserSrNo}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};




// fetch otp once user click on getOtp
export const fetchOtp = async (fkUserId, token) => {
  try {
    if (!fkUserId) {
      throw new Error("No fkUserId found.");
    }

    const response = await Axios.get(`/fieldotp/getOtp/${fkUserId}`, {
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    });

  
    if (response.data) {
      return response.data; 
    }

    return null; 
  } catch (error) {
    console.error("Error fetching OTP:", error);
    throw error;
  }
};

// delete otp once otp enter succefully

export const deleteOtp = async (pkFieldotpId) => {
  try {
  

    const token = sessionStorage.getItem('token'); 
    if (!token) {
      throw new Error("No authorization token found.");
    }

    console.log("Deleting OTP ID:", pkFieldotpId);
    console.log("Auth Token:", token);

    const response = await Axios.delete(`/fieldotp/deleteFieldOtp/${pkFieldotpId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response status:", response.status);
    console.log("Response data:", response.data);

    return {
      success: response.status === 200 || response.status === 204,
      status: response.status,
      data: response.data || null,
    };

  } catch (error) {
    console.error("Error deleting OTP:", error);

    return {
      success: false,
      status: error.response?.status || 500,
      error: error.response?.data || error.message || "Unknown error",
    };
  }
};







